<div class="card-option" [ngClass]="{ selected: selected, selectable: selectable }">
  <osp-icon [icon]="icon" [iconSize]="'xLarge'" iconColor="text-primary"></osp-icon>
  <div class="card-option__label">{{ label }}</div>
  @if (description) {
    <div class="card-option__description" [innerHTML]="description"></div>
  }
</div>
